import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { visibleZonesMapSelector, zoneDetailViewSelector, zonesSelector } from '../../../features/places/placesSlice';
import { setNeedBounding } from '../../../features/map/mapSlice';

const GoogleMapZoneBounder = ({ map }) => {
    const dispatch = useDispatch();
    const visibleZonesMap = useSelector(visibleZonesMapSelector);
    const zoneDetailView = useSelector(zoneDetailViewSelector);
    const zones = useSelector(zonesSelector)


    useEffect(() => {
        const mapBounder = () => {
            if (map && window.google) {
                let bounds = new window.google.maps.LatLngBounds();
                if (zoneDetailView) {
                    if (zones[`${zoneDetailView}`]) {
                        if (zones[`${zoneDetailView}`].zone_coords) {
                            if (zones[`${zoneDetailView}`].zone_coords.length > 2) {
                                zones[`${zoneDetailView}`].zone_coords.forEach(zc => {
                                    if (!isNaN(parseFloat(zc.lat)) && !isNaN(parseFloat(zc.lng))) {
                                        let point = new window.google.maps.LatLng(
                                            parseFloat(zc.lat),
                                            parseFloat(zc.lng),
                                        );
                                        bounds.extend(point);
                                    }
                                });
                                map.fitBounds(bounds, { left: 350, bottom: 100, top: 75, right: 25 });
                            }
                        }
                    }
                    dispatch(setNeedBounding(false));
                } else {
                    visibleZonesMap.forEach(vz => {
                        if (zones[`${vz}`]) {
                            if (zones[`${vz}`].zone_coords) {
                                if (zones[`${vz}`].zone_coords.length > 2) {
                                    zones[`${vz}`].zone_coords.forEach(zc => {
                                        if (!isNaN(parseFloat(zc.lat)) && !isNaN(parseFloat(zc.lng))) {
                                            let point = new window.google.maps.LatLng(
                                                parseFloat(zc.lat),
                                                parseFloat(zc.lng),
                                            );
                                            bounds.extend(point);
                                        }
                                    });
                                    map.fitBounds(bounds, { left: 350, bottom: 100, top: 75, right: 25 });
                                }
                            }
                        }
                    });
                    dispatch(setNeedBounding(false));
                }
            };
        };
        mapBounder();
    }, [dispatch, map, visibleZonesMap, zoneDetailView, zones]);

    return (
        <div></div>
    );
}

export default GoogleMapZoneBounder;